export const h = {
    "common": {
        "webSuffix": "- QIDI Tech",
        "email": "caixa de correio",
        "password": "senha",
        "verificationCode": "Código de verificação",
        "username": "nome de utilizador",
        "readAndAgree": "Concordo",
        "and": "e",
        "userAgreement": "Acordo do Utilizador",
        "privacyPolicy": "Política de Privacidade",
        "copy": "copyright ©  A partir de 2025, Di reserva a propriedade",
        "sendVerificationCode": "Enviar código de verificação",
        "Sending": "Envio",
        "tryAgainInSeconds": "Tente novamente em segundos",
        "userNameRequired": "indique um nome de utilizador",
        "passwordInputLabel": "Introduza por favor uma senha",
        "checkPasswordInputLabel": "Introduza a senha de confirmação",
        "userEmailRequired": "Introduza o seu endereço de e-mail",
        "userEmailInvalid": "Introduza o endereço de e-mail correcto",
        "emailCodeRequired": "Introduza o código de verificação",
        "newPasswordInputLabel": "Introduza uma nova senha",
        "confirmPasswordInputLabel": "Introduza novamente a sua senha",
        "passwordMismatchErrorLabel": "A senha introduzida duas vezes é inconsistente",
        "agreementRequired": "Por favor leia e concorde com o acordo",
        "tip": "Dicas",
        "tipAlreadyLogin": "Detectado que você fez login, redirecionado para o centro de usuários para você",
        "tipWelcomeBack": "Bem-vindo de volta",
        "tipDeleteAccountFail": "Falha ao excluir conta, a interface de exclusão da conta é temporariamente fechada",
        "pleaseAgreeFirst": "Por favor, concorde primeiro.",
        "agree": "concordo",
        "refuse": "Recusar",
        "tipNeedLogin": "Por favor, faça o login primeiro",
        "tipChangePasswordSuccess": "Senha alterada com sucesso, vamos redirecioná-lo para a página de login",
        "tipGetUserInfoSuccess": "Informações obtidas com sucesso",
        "tipGetUserInfoFail": "falha na obtenção da informação",
        "tipLoginOut": "Sair e iniciar sessão",
        "delete": "apagar",
        "back": "retorno",
        "init": "inicialização",

        "passwordInputLengthErrorLabel": "O comprimento da senha deve estar entre 6 e 20",
        "changePasswordFail": "Senha original incorrecta",
        "tipDeleteAccountSuccess": "A conta foi apagada com sucesso",
        "emailCodeSentSuccess": "O código de verificação foi emitido",
        "emailCodeSentFail": "Falha na emissão do código de verificação",
        "emailLoginFail": "O código de verificação expirou",
        "passwordLoginFail": "Senha de login incorreta",
        "editUserInfoSuccess": "Informações do utilizador modificadas com sucesso",
        "registerSuccess": "registado com sucesso",
        "registerFail": "o login falhou",
        "registerEmailExistFail": "O e- mail já existe",

        "resMessageTip0": "informação desconhecida",
        "resMessageTip1": "Erro da senha",
        "resMessageTip2": "O comprimento da senha deve estar entre 6 e 20",
        "resMessageTip3": "Erro da conta",
        "resMessageTip4": "O código de verificação foi emitido",
        "resMessageTip5": "Falha na emissão do código de verificação",
        "resMessageTip6": "O código de verificação expirou",
        "resMessageTip7": "Erro da senha",
        "resMessageTip8": "A senha não pode ser a mesma que a senha antiga",
        "resMessageTip9": "O e- mail já existe",
        "resMessageTip10": "registado com sucesso",
        "resMessageTip11": "o login falhou",
        "resMessageTip12": "Informações do utilizador modificadas com sucesso",
        "resMessageTip13": "Não foi possível modificar a informação do utilizador",
        "resMessageTip14": "Obtido com sucesso",
        "resMessageTip15": "A aquisição falhou",
        "resMessageTip16": "A senha foi alterada com sucesso",
        "resMessageTip17": "A alteração da senha falhou",
        "resMessageTip18": "A redefinição da senha foi bem sucedida",
        "resMessageTip19": "A redefinição da senha falhou",
        "resMessageTip20": "Login bem sucedido",
        "resMessageTip21": "A autenticação falhou",
        "resMessageTip22": "A conta foi apagada com sucesso",
        "resMessageTip23": "Não foi possível apagar a conta",
        "resMessageTip24": "O código de verificação está incorrecto",
        "noUserInfoError": "Erro de rede, por favor volte a ligar"
    },
    "changePassword": {
        "newPassword": "Nova senha"
    },
    "deleteUser": {
        "tipDeleteUser": "Infelizmente, tens de ir embora. Assim que sua conta for excluída, todos os seus dados pessoais desaparecerão permanentemente e não poderão ser recuperados.",
        "accountDeletionTerms": "Termos de eliminação da conta"
    },
    "forgetPassword": {
        "retrievePasswordThroughEmail": "Obter a senha por e- mail",
        "confirmPassword": "Confirmar a senha",
        "resettingPassword": "repor a senha",
        "resetting": "Repor"
    },
    "login": {
        "passwordLogin": "Senha de autenticação",
        "verifyLogin": "Verificar a autenticação",
        "accountRegistration": "Registo da conta",
        "forgotPassword": "Esqueceu- se da senha",
        "login": "Entrar",
        "localLogin": "Ligação local",
        "loginOut": "Sair",
        "continueOnYourWay": "Continue no seu caminho"
    },
    "register": {
        "registerAnAccount": "Registar uma conta",
        "register": "registo"
    },
    "userCenter": {
        "personalInformation": "dados pessoais",
        "modifyInformation": "Modificar a informação",
        "changePassword": "Mudar a Senha",
        "cancelAccount": "Cancelar conta",
        "exitAccount": "Conta de saída",
        "change": "modificar",
        "maxCharLimitTip": "O comprimento do nome de usuário não pode exceder 10 caracteres chineses",
    },
    "policies": {
        "deleteAccountPrivacy": "Apagar o Contrato da Conta",
        "agreement": "Acordo de Utilização",
        "privacyPolicy": "Política de Privacidade"
    },
    "api": {},
    "errorMsg": {},
    "area": {
        "regionalSelection": "Escolha o seu país ou região",
        "recommendedVisits": "Visita recomendada",
        "NorthAmerica": "América do Norte",
        "Europe": "Europa",
        "Asia": "Ásia",
        "Other": "outros",
    }
}
export const aAndL ={
    "ar": {
        "Country": "árabe",
        "Language": "Árabe"
    },
    "cs": {
        "Country": "República Checa",
        "Language": "Checo"
    },
    "de": {
        "Country": "Alemanha",
        "Language": "Alemão"
    },
    "en": {
        "Country": "britain",
        "Language": "Inglês"
    },
    "es": {
        "Country": "Espanha",
        "Language": "Espanhol"
    },
    "fr": {
        "Country": "França",
        "Language": "Francês"
    },
    "he": {
        "Country": "Israel",
        "Language": "Hebraico"
    },
    "hu": {
        "Country": "Hungria",
        "Language": "Língua húngara"
    },
    "it": {
        "Country": "Itália",
        "Language": "Italiano"
    },
    "ja": {
        "Country": "Japão",
        "Language": "Japonês"
    },
    "ko": {
        "Country": "República da Coreia",
        "Language": "Coreano"
    },
    "nl": {
        "Country": "Países Baixos",
        "Language": "Holandês"
    },
    "pt": {
        "Country": "Portugal",
        "Language": "Português"
    },
    "pt_BR": {
        "Country": "Portugal (Brasil)",
        "Language": "Português (Brasil)"
    },
    "ru": {
        "Country": "Rússia",
        "Language": "Russo"
    },
    "sv": {
        "Country": "Suécia",
        "Language": "Língua sueca"
    },
    "tr": {
        "Country": "Türkiye",
        "Language": "Turco"
    },
    "uk": {
        "Country": "Ucrânia",
        "Language": "Língua ucraniana"
    },
    "zh": {
        "Country": "China Continental",
        "Language": "Chinês simplificado"
    },
    "zh_tw": {
        "Country": "Taiwan, China",
        "Language": "Chinês tradicional"
    },
    "Canada": {
        "Country": "Canadá",
        "Language": "Inglês"
    },
    "United_States": {
        "Country": "E.U.A.",
        "Language": "Inglês"
    },
    "United_Kingdom": {
        "Country": "britain",
        "Language": "Inglês"
    },
    "EU_Countries": {
        "Country": "Países da UE",
        "Language": "Inglês"
    },
    "Australia": {
        "Country": "Austrália",
        "Language": "Inglês"
    },
    "globalzh": {
        "Country": "Global",
        "Language": "Chinês simplificado"
    },
    "globalen": {
        "Country": "Global",
        "Language": "Inglês"
    }
}



// WEBPACK FOOTER //
// ./src/i18n/lan/pt.js